var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 14,
    viewBox: "0 0 17.5 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-check",
    "data-name": "Icon awesome-user-check",
    d: "M6.125,7a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,6.125,7Zm2.45.875H8.118a4.76,4.76,0,0,1-3.987,0H3.675A3.676,3.676,0,0,0,0,11.55v1.137A1.313,1.313,0,0,0,1.313,14h9.625a1.313,1.313,0,0,0,1.313-1.312V11.55A3.676,3.676,0,0,0,8.575,7.875Zm8.832-3.511-.76-.768a.324.324,0,0,0-.459,0L13.322,6.437,12.078,5.184a.324.324,0,0,0-.459,0l-.768.763a.324.324,0,0,0,0,.459l2.234,2.25a.324.324,0,0,0,.459,0L17.4,4.823A.327.327,0,0,0,17.407,4.364Z",
    fill: "#868686"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user-check.b84aef4e1eb4fd1b02342c794a0a0ac3.svg";
export { ForwardRef as ReactComponent };